import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { appStore } from "@/hooks";
import { DetailsPanel, TextButton } from "@/components/common";
import { ArtifactBody } from "@/components/artifact/display";

/**
 * Displays artifact content.
 */
const __default__ = {
  name: "ArtifactBodyPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), { panel: "displayArtifactBody" }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        text: "",
        label: "Artifact",
        icon: "artifact",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).openDetailsPanel('displayArtifact')))
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ArtifactBody))
    ]),
    _: 1
  }))
}
}

})